export const CommonStyles = {
  body: {
    fontSize: 12,
    lineHeight: 1.25,
    padding: 20,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },
  header: {
    lineHeight: 1.25,
    display: "flex",
    flexDirection: "column",
    paddingBottom: 0,
    top: 10,
    marginBottom: 10,
    width: "100%"
  },
  logoContainer: {
    maxHeight: 50,
    maxWidth: 120,
    marginBottom: 12
  },
  logo: {
    objectFit: "contain",
    marginRight: 20
  },
  letterheadContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    border: "1pt solid #ccc",
    borderRadius: 2,
    width: "100%",
    paddingRight: 10,
    paddingLeft: 10,
    paddingTop: 1,
    paddingBottom: 1,
    marginBottom: 10
  },
  propertyImageContainer: {
    maxHeight: 20,
    maxWidth: 60
  },
  propertyImage: {
    objectFit: "contain",
    marginRight: 10
  },
  letterhead: {
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
    marginTop: 10
  },
  propertyName: {
    fontWeight: "bold",
    fontSize: 16
  },
  address: {
    fontSize: 9,
    color: "#7b7b83"
  },
  gla: {
    fontSize: 9,
    fontWeight: "bold"
  },
  legendContainer: {
    display: "flex",
    flexDirection: "row",
    height: 25,
    marginBottom: 10
  },
  legendBlock: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%"
  },
  legendText: {
    color: "#fff",
    fontWeight: "bold",
    fontSize: 7
  },
  svgContainer: { 
    width: "100%", 
    height: "25%",
    backgroundColor: "#e5e5e5",
    overflow: "hidden",
    borderRadius: 5,
    marginBottom: 10,
    position: "relative"
  },
  svg: {
    width: "100%",
    height: "120%",
    objectFit: "contain",
    position: "absolute"
  },
  row: {
    display: "flex",
    flexDirection: "row"
  },
  tenantRoster: {
    width: "100%",
    height: "50%",
    display: "flex",
    flexDirection: "column"
  },
  tenantRosterHeader: {
    fontWeight: "bold"
  },
  tenantRosterRow: {
    borderBottom: "0pt solid #ccc",
    borderBottomWidth: 0.5,
    alignItems: "center",
    marginBottom: 8
  },
  tenantRosterColumn: {
    marginBottom: 5
  },
  tenantRosterLabelColumn: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    paddingBottom: 5
  },
  tenantRosterColumnName: {
    fontSize: 7,
    color: "#828289",
    fontWeight: "bold"
  },
  tenantRosterColumnText: {
    fontSize: 7,
    color: "#828289",
    width: "80%"
  },
  tenantRosterLabelText: {
    fontSize: 7
  },
  statusLabel: {
    opacity: 0.1, 
    display: "flex", 
    flexDirection: "row", 
    alignSelf: "flex-start", 
    alignItems: "center",
    padding: "1pt 6pt",
    borderRadius: 10,
    marginRight: 3,
    marginBottom: 3
  },
  footer: {
    position: "absolute",
    bottom: 10,
    marginLeft: 20,
    display: "flex",
    flexDirection: "row",
    width: "100%",
    fontSize: 6,
    paddingTop: 8,
    borderTop: "1pt solid #000",
    justifyContent: "space-between"
  }
}